import { addDays, addMonths, startOfDay } from "date-fns";

import { OrderDateOption } from "./orderDateOptions";

export const getMinimumDate = (filter: OrderDateOption): Date => {
  switch (filter) {
    case "1month":
      return addMonths(new Date(), -1);
    case "2months":
      return addMonths(new Date(), -2);
    case "3months":
      return addMonths(new Date(), -3);
    case "4months":
      return addMonths(new Date(), -4);
    case "7days":
      return addDays(new Date(), -7);
    case "yesterday": {
      const startOfToday = startOfDay(new Date());
      return addDays(startOfToday, -1);
    }
    case "today":
      return startOfDay(new Date());
    default:
      throw new Error("Invalid filter");
  }
};
